// use.keyboard.ts
import { useEffect, useState } from 'react';
import { Keyboard, Platform } from 'react-native';

export function useKeyboard() {
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);

  useEffect(() => {
    if (Platform.OS === 'web') {
      if (typeof window === 'undefined' || !window.visualViewport) return;

      let baseHeight = window.visualViewport.height;
      let baseWidth = window.visualViewport.width;

      const handleResize = () => {
        if (!window.visualViewport) return;

        const currentHeight = window.visualViewport.height;
        const currentWidth = window.visualViewport.width;

        // 1. Detect Orientation Change (user rotated the device)
        if (Math.abs(baseWidth - currentWidth) > 50) {
          baseWidth = currentWidth;
          baseHeight = currentHeight;
          setIsKeyboardVisible(false);
          return;
        }

        // 2. Detect Keyboard (height shrank significantly without width changing)
        const MIN_KEYBOARD_HEIGHT = 150;
        if (baseHeight - currentHeight > MIN_KEYBOARD_HEIGHT) {
          setIsKeyboardVisible(true);
        } else {
          setIsKeyboardVisible(false);
          // If the viewport grows (e.g., address bar collapses), update the max height
          if (currentHeight > baseHeight) {
            baseHeight = currentHeight;
          }
        }
      };

      window.visualViewport.addEventListener('resize', handleResize);
      return () => {
        window.visualViewport?.removeEventListener('resize', handleResize);
      };
    }

    // React Native behavior remains untouched
    const listener1 = Keyboard.addListener('keyboardDidHide', () => setIsKeyboardVisible(false));
    const listener2 = Keyboard.addListener('keyboardDidShow', () => setIsKeyboardVisible(true));
    return () => {
      listener1.remove();
      listener2.remove();
    };
  }, []);

  return { isKeyboardVisible };
}
